import { AxiosResponseTransformer, AxiosInstance } from 'axios';
import { setCSRFTokenHeader } from './ajax-handlers-csrf';

const dateISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[.,]\d+)?Z?$/i;
const dateISOMilliseconds = /[.,](\d+)/i;

function dateFromString(date: string) {
    if (dateISO.test(date)) {
        const ms = dateISOMilliseconds.exec(date);
        const fixedValue = date.replace(dateISOMilliseconds, '');
        const result = new Date(fixedValue);

        if (ms !== null) {
            let millisecond = parseInt(ms[1].substr(0, 3), 10);
            millisecond = isNaN(millisecond) ? 0 : millisecond;
            result.setMilliseconds(millisecond);
        }

        return result;
    }

    return date;
}

export const initAjaxHandlersCommon = (inst: AxiosInstance) => {
    const transformer: AxiosResponseTransformer = (data: any) => {
        if (typeof data === 'string') {
            return dateFromString(data);
        }

        if (typeof data === 'object') {
            if (data instanceof Blob) {
                return data;
            }

            try {
                // parsing each values one by one to see if it is a date
                return JSON.parse(JSON.stringify(data), (_0, value) => {
                    if (typeof value === 'string') {
                        return dateFromString(value);
                    }

                    return value;
                });
            } catch {
                return data;
            }
        }

        return data;
    };

    if (inst.defaults.transformResponse === undefined) {
        inst.defaults.transformResponse = [transformer];
    } else if (Array.isArray(inst.defaults.transformResponse)) {
        inst.defaults.transformResponse.push(transformer);
    } else {
        inst.defaults.transformResponse = [inst.defaults.transformResponse, transformer];
    }

    inst.interceptors.request.use(config => {
        const absoluteUrlRegex = /^(?:[a-z]+:)?\/\//i;

        const headers: any = {
            Accept: 'application/json',
        };

        if (!(config.data instanceof FormData)) {
            headers['Content-Type'] = 'application/json;charset=UTF-8';
        }

        if (config.url && !absoluteUrlRegex.test(config.url)) {
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }

        config.headers = { ...headers, ...config.headers };
        const configWithCSRFToken = setCSRFTokenHeader(config);
        return configWithCSRFToken;
    });

    inst.defaults.validateStatus = status => status >= 200 && status < 400;
};
